__turbopack_context__.v({
  "buttonWrapper": "AppStoreButton-module-scss-module__Ry_0eq__buttonWrapper",
});
